// Shivs
import './utils/BasicShiv';

// D3
import * as d3 from 'd3';

// Views
// import Chords from './chord';
import Circles from './circles';
import Lines from './lines';
import Links from './links';

// General CSS
import '../../css/main.scss';

// Debug
import debug from './utils/Debug';

// Vue UI
import './ui';

// Fonts
import 'Assets/fonts/flama.css';

// EventSystem
import EventSystem from './utils/EventSystem';

// Expose d3 globally
window.d3 = d3;

window.$phpData = window.$phpData
  .sort((a, b) => a < b ? -1 : (a > b ? 1 : 0))
;

let frentesJson = window.$phpData.findIndex(e => e.match(/frentes\.json/gi));
frentesJson = window.$phpData.splice(frentesJson, 1);

d3.json(frentesJson, data => {
  window.$fronts = window.$phpData.map((f, i) => ({
    name: data[i],
    file: f,
    value: f.split('/').pop(),
  }));

  kickstart();

  EventSystem.$emit('fronts-loaded');
});

const kickstart = () => {
  const circlesView = new Circles();

  EventSystem.$on('first-front-selected', front => {
    circlesView.loadFront(front.file);
  });
  EventSystem.$on('front-changed', () => {
    linesView.hide();
    linksView.hide();
  });
  EventSystem.$on('area-changed', () => {
    linesView.hide();
    linksView.hide();
  });

  EventSystem.$on('view-change', n => {
    if (n === 1) {
      circlesView.show();
      linesView.hide();
      linksView.hide();
    } else if (n === 2) {
      const nodesCopy = circlesView.filteredNodes.map(node => ({ ...node }));

      circlesView.hide();
      linesView.hide();

      linksView.updateView(nodesCopy);
      linksView.show();
    } else {
      const nodesCopy = circlesView.filteredNodes.map(node => ({ ...node }));

      circlesView.hide();
      linksView.hide();

      linesView.updateView(nodesCopy);
      linesView.show();
    }
  });

  const linesView = new Lines({ hidden: true });
  const linksView = new Links({ hidden: true });
};



// WEBPACK FOOTER //
// ./assets/js/source/main.js